export const SET_REQUEST_IN_PROCESS = '@@request/SET_REQUEST_IN_PROCESS';
export const SET_REQUEST_IN_PROCESS_SUCCESS = '@@request/SET_REQUEST_IN_PROCESS_SUCCESS';
